<template>
  <div
    @focus="handleFocus"
    @focusout="handleFocusOut"
    tabindex="0"
    ref="frame"
    class="popup-wrapper">
    <div class="flex flex-col popup-background" tabindex="1">
      <div class="send-reminder-cont mb-2">
        <p>Yeni <strong>Kamera</strong> eklemek için formu doldurum ve Onayla tuşuna basın. </p>
      </div>
      <div class="flex flex-col">
        <div class="w-full flex">
          <div class="w-1/3 regular-input-field mr-2 flex flex-col">
            <span class="text-label">Enlem</span>
            <input class="w-full regular-input"
                   type="text"
                   v-model="enlem"
                   placeholder="Enlem"
                   data-vv-name="Enlem"
                   v-validate="'required'">

            <span class="text-danger text-sm" v-show="errors.has('Enlem')">{{ errors.first('Enlem') }}</span>
          </div>
          <div class="w-1/3 regular-input-field mr-2 flex flex-col">
            <span class="text-label">Boylam</span>
            <input class="w-full regular-input"
                   type="text"
                   v-model="boylam"
                   placeholder="Boylam"
                   data-vv-name="Boylam"
                   v-validate="'required'">

            <span class="text-danger text-sm" v-show="errors.has('Boylam')">{{ errors.first('Boylam') }}</span>
          </div>
          <div class="w-1/3 regular-input-field flex flex-col">
            <span class="text-label">Rakım</span>
            <input class="w-full regular-input"
                   type="text"
                   v-model="rakim"
                   placeholder="Rakım"
                   data-vv-name="Rakim"
                   v-validate="'required'">

            <span class="text-danger text-sm" v-show="errors.has('Rakim')">{{ errors.first('Rakim') }}</span>
          </div>
        </div>
        <div class="w-full flex">

          <div class="w-1/3 regular-input-field mr-2 flex flex-col">
            <span class="text-label">Kuzey Sabiti</span>
            <input class="w-full regular-input"
                   type="text"
                   v-model="kuzey_sabiti"
                   placeholder="Kuzey Sabiti"
                   data-vv-name="Kuzey Sabiti"
                   v-validate="'required'">

            <span class="text-danger text-sm" v-show="errors.has('Kuzey Sabiti')">{{ errors.first('Kuzey Sabiti') }}</span>
          </div>
          <div class="w-1/3 regular-input-field mr-2 flex flex-col">
            <span class="text-label">Max Pan</span>
            <input class="w-full regular-input"
                   type="text"
                   v-model="max_pan"
                   placeholder="Max Pan"
                   data-vv-name="Max Pan"
                   v-validate="'required'">

            <span class="text-danger text-sm" v-show="errors.has('Max Pan')">{{ errors.first('Max Pan') }}</span>
          </div>
          <div class="w-1/3 regular-input-field flex flex-col">
            <span class="text-label">Max Tilt</span>
            <input class="w-full regular-input"
                   type="text"
                   v-model="max_tilt"
                   placeholder="Max Tilt"
                   data-vv-name="Max Tilt"
                   v-validate="'required'">

            <span class="text-danger text-sm" v-show="errors.has('Max Tilt')">{{ errors.first('Max Tilt') }}</span>
          </div>
        </div>
        <div class="w-full flex">
          <div class="w-1/3 regular-input-field mr-2 flex flex-col">
            <span class="text-label">Tilt Value</span>
            <input class="w-full regular-input"
                   type="text"
                   v-model="tilt_value"
                   placeholder="Tilt Value"
                   data-vv-name="Tilt Value"
                   v-validate="'required'">

            <span class="text-danger text-sm" v-show="errors.has('Tilt Value')">{{ errors.first('Tilt Value') }}</span>
          </div>
          <div class="w-1/3 regular-input-field mr-2 flex flex-col">
            <span class="text-label">Cam Type</span>
            <input class="w-full regular-input"
                   type="text"
                   disabled
                   v-model="cam_type"
                   placeholder="Cam Type">
          </div>
          <div class="w-1/3 regular-input-field flex flex-col">
            <span class="text-label">IP</span>
            <input class="w-full regular-input"
                   type="text"
                   v-model="ip"
                   placeholder="IP"
                   data-vv-name="IP"
                   v-validate="'required'">

            <span class="text-danger text-sm" v-show="errors.has('IP')">{{ errors.first('IP') }}</span>
          </div>
        </div>

        <div class="w-full flex">
          <div class="w-1/3 regular-input-field mr-2 flex flex-col">
            <span class="text-label">Port</span>
            <input class="w-full regular-input"
                   type="text"
                   v-model="port"
                   placeholder="Port"
                   data-vv-name="Port"
                   v-validate="'required'">

            <span class="text-danger text-sm" v-show="errors.has('Port')">{{ errors.first('Port') }}</span>
          </div>
          <div class="w-1/3 regular-input-field mr-1 flex flex-col">
            <span class="text-label">Username</span>
            <input class="w-full regular-input"
                   type="text"
                   v-model="username"
                   placeholder="Username"
                   data-vv-name="Username"
                   v-validate="'required'">

            <span class="text-danger text-sm" v-show="errors.has('Username')">{{ errors.first('Username') }}</span>
          </div>
          <div class="w-1/3 regular-input-field ml-1 flex flex-col">
            <span class="text-label">Password</span>
            <input class="w-full regular-input"
                   type="text"
                   v-model="password"
                   placeholder="Password"
                   data-vv-name="Password"
                   v-validate="'required'">

            <span class="text-danger text-sm" v-show="errors.has('Password')">{{ errors.first('Password') }}</span>
          </div>
        </div>
        <div class="w-full flex">
          <div class="w-1/3 regular-input-field mr-1 flex flex-col">
            <span class="text-label">CSV File Name</span>
            <input class="w-full regular-input"
                   type="text"
                   v-model="csv_file_name"
                   placeholder="CSV File"
                   data-vv-name="CSV File">

            <span class="text-danger text-sm" v-show="errors.has('CSV File')">{{ errors.first('CSV File') }}</span>
          </div>
          <div class="w-1/3 regular-input-field ml-1 flex flex-col">
            <span class="text-label">Alarm Node</span>
            <input class="w-full regular-input"
                   type="text"
                   v-model="alarm_node"
                   placeholder="Alarm Node"
                   data-vv-name="Alarm Node"
                   v-validate="'required'">

            <span class="text-danger text-sm" v-show="errors.has('Alarm Node')">{{ errors.first('Alarm Node') }}</span>
          </div>
        </div>

        <div class="w-full flex">
          <div class="w-1/3 regular-input-field mr-1">
            <div class="flex">
              <input type="checkbox" v-model="tespit_var"/>
              <div class="flex flex-col">
                <span class="aggrement-label pl-2">Tespit</span>
              </div>
            </div>
          </div>
          <div class="w-1/3 regular-input-field ml-1">
            <div class="flex">
              <input type="checkbox" v-model="koordinat_hesapla"/>
              <div class="flex flex-col">
                <span class="aggrement-label pl-2">Koordinat Hesapla</span>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full regular-input-field ml-1">
          <div class="flex flex-col">
            <span class="text-label">Kule</span>
            <select class="w-full regular-input-field" v-model="selected_kule">
              <option :value="kule.value" :key="index" v-for="(kule, index) in kule_options">{{kule.label}}</option>
            </select>
          </div>
        </div>
        <div class="regular-input-field">
          <span><i>Type:</i> {{ cam_type }}</span>
        </div>

      </div>
      <div class="w-full mt-4">
        <div class="popup-button blue-button" @click="confirm">Onayla</div>
        <div class="popup-button black-button" @click="cancel">Vazgeç</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    kule: {
      type: Object
    },
    kamera: {
      type: Object
    },
    updated: {
      type: Function
    },
    cancelled: {
      type: Function
    },
    code: {
      type: String
    }
  },
  name: 'KameraPopup',
  mounted () {
    if (this.kamera) {
      this.loadData(this.kamera)
    }
  },
  data () {
    return {
      enlem: '',
      boylam: '',
      rakim: '',
      cam_type: 'BRICKCOM',
      kuzey_sabiti: '',
      max_pan: '',
      max_tilt: '',
      tilt_value: '',
      ip: '',
      port: '',
      username: '',
      password: '',
      csv_file_name: '',
      tespit_var: true,
      koordinat_hesapla: true,
      alarm_node: '',
      selected_kule: 0
    }
  },
  computed: {
    kule_data () {
      return this.$store.state.kule_list
    },
    kule_options () {
      const options_array = []

      this.kule_data.map(kule => {
        const option = {
          label: kule.name,
          value: kule.id
        }
        options_array.push(option)
      })
      return options_array
    }
  },
  methods: {

    getData () {
      this.$vs.loading()
      const payload = {
        page: this.page,
        items: this.max
      }
      this.$store.dispatch('getKuleList', payload)
        .then(result => {
          this.count = result.data.count
          console.log('get kule list success', result, this.count)
          this.$vs.loading.close()
        })
        .catch(e => {
          console.log('get kule error', e)
          this.$vs.loading.close()
        })
    },
    handleFocus () {
      // do something here
      console.log('in')
      this.cancel()
    },
    handleFocusOut () {
      // do something here
      console.log('out')
    },
    resetData () {
      this.enlem = ''
      this.boylam = ''
      this.rakim = ''
      this.cam_type = 'BRICKCOM'
      this.kuzey_sabiti = ''
      this.max_pan = ''
      this.max_tilt = ''
      this.tilt_value = ''
      this.ip = ''
      this.port = ''
      this.username = ''
      this.password = ''
      this.csv_file_name = ''
      this.tespit_var = true
      this.koordinat_hesapla = true
      this.alarm_node = ''
    },
    loadData (kamera) {
      const {
        enlem,
        boylam,
        rakim,
        cam_type,
        kuzey_sabiti,
        max_pan,
        max_tilt,
        tilt_value,
        ip,
        port,
        username,
        password,
        csv_file_name,
        tespit_var,
        koordinat_hesapla,
        kule_id,
        alarm_node  } = JSON.parse(JSON.stringify(kamera))
      this.enlem = enlem
      this.boylam = boylam
      this.rakim = rakim
      this.cam_type = cam_type
      this.kuzey_sabiti = kuzey_sabiti
      this.max_pan = max_pan
      this.max_tilt = max_tilt
      this.tilt_value = tilt_value
      this.ip = ip
      this.port = port
      this.username = username
      this.password = password
      this.csv_file_name = csv_file_name
      this.tespit_var = tespit_var === '1'
      this.koordinat_hesapla = koordinat_hesapla === '1'
      this.alarm_node = alarm_node
      this.selected_kule = kule_id
    },
    addKamera (payload) {
      this.$store.dispatch('addKamera', payload)
        .then((response) => {
          console.log('kule', response)
          this.$vs.loading.close()
          this.updated(response)
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        })
    },
    editKamera (payload) {
      this.$store.dispatch('editKamera', payload)
        .then((response) => {
          console.log('kule', response)
          this.$vs.loading.close()
          this.updated(response)
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        })
    },
    duplicateKamera (payload) {
      this.$store.dispatch('addKamera', payload)
        .then((response) => {
          console.log('kule', response)
          this.$vs.loading.close()
          this.updated(response)
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        })
    },
    confirm () {
      //this.updated(this.code)
      return new Promise(() => {
        this.$validator.validateAll().then(result => {
          if (result) {
            const payload = {
              kule_id: this.selected_kule,
              enlem: this.enlem,
              boylam: this.boylam,
              rakim: this.rakim,
              cam_type: this.cam_type,
              kuzey_sabiti: this.kuzey_sabiti,
              max_pan: this.max_pan,
              max_tilt: this.max_tilt,
              tilt_value: this.tilt_value,
              ip: this.ip,
              port: this.port,
              username: this.username,
              password: this.password,
              csv_file_name: this.csv_file_name,
              tespit_var: this.tespit_var ? '1' : '0',
              koordinat_hesapla: this.koordinat_hesapla ? '1' : '0',
              alarm_node: this.alarm_node
            }
            console.log('kule payload', payload)

            if (this.kamera && !this.kamera.duplicate) {
              payload.id = this.kamera.id
              this.editKamera(payload)
            } else {
              this.addKamera(payload)
            }
          } else {
            this.$vs.notify({
              title: 'Hata',
              text: 'Lütfen gerekli alanları doldurun',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
          }
        })
      })
    },
    cancel () {
      this.cancelled()
      this.resetData()
    }
  }
}
</script>

<style lang="scss">
</style>
